export default __webpack_public_path__ + "static/media/emerald-empty-checkbox.94580169.svg";